module.exports = __webpack_public_path__ + "img/w31b.403dab12.jpg";